// Gestores (7-oct-2026): la pestaña «Gestión» de Analítica y los filtros de gestionados /
// propios / propietario de las pestañas Desempeño y Canales.
export const gestionAnalytics = {
  tab: "الإدارة",
  tabRestricted: "كشف حسابي",
  restrictedTitle: "كشف حسابي",

  pageFilters: {
    ownership: "أماكن الإقامة",
    ownershipAll: "المُدارة والخاصة",
    ownershipManaged: "المُدارة فقط",
    ownershipOwn: "الخاصة فقط",
    owner: "المالك",
    allOwners: "جميع الملاك",
  },

  views: {
    business: "أعمالي",
    owners: "الملاك",
    expenses: "المصروفات",
  },

  filters: {
    listings: "أماكن الإقامة",
    allListings: "الكل",
    someListings: "{count} أماكن إقامة",
    owner: "المالك",
    allOwners: "الكل",
    attribution: "احتساب الحجوزات حسب",
    checkout: "تاريخ المغادرة",
    checkin: "تاريخ الوصول",
    nights: "ليالي الفترة",
    attributionHelp: "الاحتساب حسب المغادرة هو أساس التسوية مع الملاك: فالإقامة قد انتهت بالفعل.",
    attributionHelpLabel: "ما معنى «احتساب الحجوزات حسب»",
    currency: "العملة",
  },

  warnings: {
    otaEstimated:
      "{count} حجز بعمولة OTA مقدَّرة بالنسبة المئوية: لم تُبلِغ القناة عن العمولة الفعلية. | {count} حجوزات بعمولة OTA مقدَّرة بالنسبة المئوية: لم تُبلِغ القناة عن العمولة الفعلية.",
    noBreakdown:
      "{count} حجز بلا تفصيل: احتُسب مبلغه كاملاً كإقامة. | {count} حجوزات بلا تفصيل: احتُسب مبلغها كاملاً كإقامة.",
    outdatedBreakdown:
      "{count} حجز عُدِّل أو مُدِّد بعد استيراده: اعتُمد مبلغه الحالي. | {count} حجوزات عُدِّلت أو مُدِّدت بعد استيرادها: اعتُمد مبلغها الحالي.",
    otherCurrencies: "توجد أماكن إقامة بعملة أخرى ({currencies}). غيِّر العملة في الأعلى لعرضها.",
    noOwner:
      "{count} مكان إقامة مُدار بلا مالك معيَّن. | {count} أماكن إقامة مُدارة بلا مالك معيَّن.",
    assignOwners: "تعيين الملاك",
  },

  states: {
    loadError: "تعذّر تحميل بيانات الإدارة.",
    forbidden: "ليست لديك صلاحية لعرض هذه المعلومات.",
    periodTooLong: "اختر فترة لا تتجاوز سنتين.",
    retry: "إعادة المحاولة",
    noMovements: "لا توجد حركات في هذه الفترة",
  },

  empty: {
    title: "هل تدير أماكن إقامة لملاك آخرين؟",
    text: "حدِّد في كل مكان إقامة أنك تديره لصالح مالك، وبأي شروط: عمولتك، ومن يحصِّل مبالغ الحجوزات، وكيف يُدار التنظيف. ستجد هنا ما تكسبه أنت وما يستحقه كل مالك.",
    point1: "عمولاتك والتنظيف والمصروفات، مع ربحك الفعلي",
    point2: "ما يجب تحويله إلى كل مالك أو تحصيله منه",
    point3: "كشف حساب كل مالك بصيغة PDF أو Excel",
    cta: "إعداد أماكن الإقامة",
  },

  period: {
    subtitle: "{period} · {attribution} · {granularity}",
    byCheckout: "الحجوزات حسب تاريخ المغادرة",
    byCheckin: "الحجوزات حسب تاريخ الوصول",
    byNights: "ليالي الفترة",
    day: "يومياً",
    week: "أسبوعياً",
    month: "شهرياً",
  },

  counts: {
    reservations: "{count} حجز | {count} حجوزات",
    nights: "{count} ليلة | {count} ليالٍ",
    units: "{count} مكان إقامة | {count} أماكن إقامة",
    ownUnits: "{count} مكان إقامة خاص | {count} أماكن إقامة خاصة",
    owners: "{count} مالك | {count} ملاك",
  },

  business: {
    kpi: {
      managedGross: "الإيرادات المُدارة",
      commissions: "عمولاتك",
      cleaning: "التنظيف",
      ownRevenue: "إيرادات العقارات الخاصة",
      expenses: "المصروفات",
      profit: "الربح",
    },
    vatLine: "+ ض.ق.م {amount}",
    ofTotal: "من إجمالي الإيرادات",
    overManaged: "من الإيرادات المُدارة",
    ofIncome: "من دخلك",
    margin: "هامش الربح",
    chartTitle: "الدخل والمصروفات والربح",
    chartA11y: "رسم بياني للدخل والمصروفات والربح خلال الفترة",
    legend: {
      commissions: "العمولات",
      cleaning: "التنظيف",
      own: "العقارات الخاصة",
      expenses: "المصروفات",
      profit: "الربح",
    },
    byCategory: "المصروفات حسب الفئة",
    category: "الفئة",
    amount: "المبلغ",
    noExpenses: "لا توجد مصروفات في هذه الفترة",
    seeExpenses: "عرض المصروفات",
  },

  owners: {
    kpi: {
      gross: "إيرادات الحجوزات",
      ota: "عمولات OTA",
      cleaning: "التنظيف",
      commission: "عمولتك + ض.ق.م",
      commissionRestricted: "عمولة المدير + ض.ق.م",
      charged: "المصروفات المحمَّلة على الملاك",
      net: "الصافي للملاك",
      netRestricted: "صافيك",
    },
    ofGross: "من الإيرادات",
    collectedByYou: "تحصِّله أنت",
    collectedByManager: "يحصِّله مديرك",
    commissionLine: "{commission} + ض.ق.م {vat}",
    otaLine: "{commission} + ض.ق.م {vat}",
    otaTitle: "عمولة منصات الحجز {commission} + ض.ق.م {vat}",
    commissionTitle: "العمولة {commission} + ض.ق.م {vat}",
    toTransfer: "للتحويل إلى الملاك",
    toCollect: "للتحصيل من الملاك",
    toTransferRestricted: "يحوِّله إليك مديرك",
    toCollectRestricted: "للدفع إلى مديرك",
    chartTitle: "توزيع الإيرادات",
    chartA11y: "رسم بياني لتوزيع إيرادات الحجوزات المُدارة",
    legend: {
      net: "صافي الملاك",
      netRestricted: "صافيك",
      commissions: "عمولاتك",
      commissionsRestricted: "عمولة المدير",
      ota: "عمولات OTA",
      cleaning: "التنظيف",
      other: "الرسوم والتأمينات وض.ق.م والمصروفات",
    },
    grossFooter: "الإيرادات: {amount}",
    tableTitle: "كشف الحساب حسب المالك",
    tableTitleRestricted: "تفاصيل كشف حسابك",
    downloadAll: "تنزيل الكل (PDF)",
    download: "تنزيل (PDF)",
    downloading: "جارٍ التنزيل…",
    pdf: "PDF",
    excel: "Excel",
    exportError: "تعذّر تنزيل كشف الحساب.",
    cols: {
      owner: "المالك",
      reservations: "الحجوزات",
      gross: "الإيرادات",
      ota: "OTA",
      cleaning: "التنظيف",
      commission: "العمولة + ض.ق.م",
      charged: "المصروفات",
      net: "الصافي",
      balance: "الرصيد",
      actions: "التنزيلات",
    },
    noOwner: "بلا مالك معيَّن",
    transfer: "تحويل {amount}",
    collect: "تحصيل {amount}",
    receive: "مستحق لك {amount}",
    pay: "مستحق عليك {amount}",
    collectionManager: "يحصِّل المدير",
    collectionOwner: "يحصِّل المالك",
    total: "الإجمالي",
    expand: "عرض تفاصيل {name}",
    collapse: "إخفاء تفاصيل {name}",
    iban: "IBAN {iban}",
    showReservations: "عرض الحجوزات ({count})",
    hideReservations: "إخفاء الحجوزات",
    noData: "لا توجد حجوزات مُدارة في هذه الفترة.",
    reservations: {
      checkIn: "الوصول",
      checkOut: "المغادرة",
      guest: "الضيف",
      listing: "مكان الإقامة",
      channel: "القناة",
      gross: "الإيرادات",
      ota: "OTA",
      cleaning: "التنظيف",
      commission: "العمولة",
      vat: "ض.ق.م",
      net: "الصافي",
      direct: "مباشر",
      estimated: "تقديري",
      estimatedHelp: "مقدَّرة بالنسبة المئوية: لم تُبلِغ القناة عن العمولة الفعلية.",
      noBreakdown: "بلا تفصيل",
      noBreakdownHelp: "لا يتضمن الحجز تفصيلاً: احتُسب مبلغه كاملاً كإقامة.",
      complete: "Complete",
      completed: "Completed",
      completeHelp: "Fill in cleaning, the real OTA commission or the cleaning for this booking",
      manual: "manual",
      manualHelp: "OTA commission entered by hand for this booking.",
      loading: "جارٍ تحميل الحجوزات…",
      loadError: "تعذّر تحميل الحجوزات.",
      empty: "لا توجد حجوزات في هذه الفترة.",
    },
    charged: {
      title: "المصروفات المحمَّلة على المالك",
      date: "التاريخ",
      concept: "الوصف",
      listing: "مكان الإقامة",
      amount: "المبلغ",
      general: "عام",
    },
  },

  a11y: {
    views: "أقسام الإدارة",
  },
  // Liquidación por propietario: la cuenta y las columnas del PDF.
  liq: {
    precio: "السعر",
    comision: "عمولة المنصة",
    tasas: "الضرائب",
    limpieza: "التنظيف",
    honorarios: "الأتعاب",
    honorariosIva: "الأتعاب + الضريبة",
    neto: "صافي المالك",
    transfieres: "تحوّل له",
    tePaga: "يدفع لك",
    recibes: "تستلم",
    pagas: "تدفع",
    netoPropietarios: "الصافي للملاك",
    formula: "الدخل = السعر − العمولة · الإجمالي = الدخل − الضرائب − التنظيف · الصافي = الإجمالي − الأتعاب − الضريبة. كما في PDF وExcel.",
    cols: {
      origen: "المصدر",
      nombre: "الاسم",
      entrada: "الوصول",
      salida: "المغادرة",
      precio: "السعر",
      noches: "الليالي",
      comision: "العمولة",
      ingreso: "الدخل",
      tasas: "الضرائب",
      limpieza: "التنظيف",
      total: "الإجمالي",
      honorarios: "الأتعاب",
      iva: "الضريبة",
      neto: "الصافي",
    },
  },
};
